(function () {
  const navWrapper = document.querySelector('.gds-nav-wrapper');
  if (!navWrapper) return;

  const triggers = navWrapper.querySelectorAll('.gds-has-mega');
  const panels = navWrapper.querySelectorAll('.gds-mega-panel');

  function closeAll() {
    triggers.forEach((trigger) => trigger.classList.remove('is-active'));
    panels.forEach((panel) => panel.classList.remove('is-open'));
  }

  function openPanel(menuName) {
    closeAll();

    const trigger = navWrapper.querySelector(`[data-menu="${menuName}"]`);
    const panel = navWrapper.querySelector(`[data-panel="${menuName}"]`);

    if (trigger && panel) {
      trigger.classList.add('is-active');
      panel.classList.add('is-open');
    }
  }

  triggers.forEach((trigger) => {
    const menuName = trigger.getAttribute('data-menu');

    trigger.addEventListener('mouseenter', () => {
      if (window.innerWidth > 989) {
        openPanel(menuName);
      }
    });

    trigger.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();

      const panel = navWrapper.querySelector(`[data-panel="${menuName}"]`);
      const isOpen = panel && panel.classList.contains('is-open');

      if (isOpen) {
        closeAll();
      } else {
        openPanel(menuName);
      }
    });
  });

  panels.forEach((panel) => {
    panel.addEventListener('click', (event) => {
      event.stopPropagation();
    });
  });

  navWrapper.addEventListener('mouseleave', () => {
    if (window.innerWidth > 989) {
      closeAll();
    }
  });

  document.addEventListener('click', () => {
    closeAll();
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      closeAll();
    }
  });
})();